import { arrayToObject, deleteProperty } from "@/services/helpers";

export const reset = (state) => {
  state.list = {};
};

export const init = (state, payload) => {
  state.list = arrayToObject(payload.paymentTypes, "id");
};

export const addPaymentType = (state, payload) => {
  state.list = { ...state.list, [payload.id]: payload };
};

export const updatePaymentType = (state, payload) => {
  state.list[payload.id] = { ...state.list[payload.id], ...payload };
};

export const processDeletedPaymentType = (state, payload) => {
  state.list = deleteProperty(state.list, payload.id.toString());
};
